export default "__VITE_ASSET__IkMUkjP6__"